<template>
  <el-card>
    <ul>
      <li v-for="(item, index) in hot_shoot" :key="index">
        <el-divider content-position="left">{{ item.name_js }}</el-divider>
        <!-- <h3>英超</h3> -->
        <dl>
          <dd v-for="(ii, i) in item.player_list" :key="i">
            <div class="img_name">
              <span
                :class="
                  i === 0
                    ? 'span_color1'
                    : i === 1
                    ? 'span_color2'
                    : 'span_color3'
                "
                >{{ i + 1 }}</span
              >
              <div class="player_photo">
                <img
                  v-if="ii.player_photo"
                  :src="`${$imgUrl}/player/${ii.player_photo}`"
                />
                <img v-else src="@/assets/empty.jpg" />
              </div>

              <el-link type="primary" :underline="false">
                <router-link
                  target="_blank"
                  :to="`/soccer/players/${ii.player_id}`"
                  v-if="ii.player_id"
                  style="color: #409eff"
                >
                  {{ $filters.coach_jh(ii.player_name) }}
                </router-link></el-link
              >
            </div>
            <div class="team_name ovFl">
              <el-link
                :underline="false"
                v-for="(z, zz) in ii.team_names.split(',')"
                :key="zz"
              >
                <router-link
                  target="_blank"
                  :to="`/soccer/team/${ii.team_ids.split(',')[zz]}/lineup`"
                  >{{ z }}</router-link
                ></el-link
              >
              <p>总:{{ ii.all_score }}球，点:{{ ii.penalty_score }}球</p>
            </div>
          </dd>
        </dl>
      </li>
    </ul>
  </el-card>
</template>

<script>
import { getCurrentInstance, ref } from 'vue'
// import useReminder from '../../../hooks/useReminder'
export default {
  setup() {
    let { proxy: _this } = getCurrentInstance()
    let hot_shoot = ref([])
    let hot_shoot_fn = async () => {
      let { data: res } = await _this.$http.get(`/soccer/hot_shoot`)
      hot_shoot.value = res.data
      console.log(res)
    }
    hot_shoot_fn()
    return {
      hot_shoot
    }
  }
}
</script>
<style lang="less">
.el-divider__text {
  color: rgb(196, 92, 92);
}
</style>
<style lang="less" scoped>
ul {
  li {
    width: 100%;
    .el-divider {
      margin: 10px 0;
    }
    dl {
      display: flex;
      justify-content: space-around;
      dd {
        width: 33.33%;
        justify-content: center;
        display: flex;
        align-items: center;
        .img_name {
          min-width: 50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          span {
            display: inline-block;
            width: 14px;
            height: 14px;
            text-align: center;
            line-height: 14px;
            border-radius: 55%;
            position: absolute;
            left: 50%;
            margin-left: 10px;
            top: 0px;
            color: #fff;
            font-size: 12px;
          }
          .span_color1 {
            background: #e6a23c;
          }
          .span_color2 {
            background: #97a2a6;
          }
          .span_color3 {
            background: #946d5a;
          }
          .player_photo {
            width: 40px;
            height: 40px;
            background: #eee;
            display: flex;
            justify-content: center;
            overflow: hidden;
            border-radius: 50%;
            img {
              width: 30px;
              // height: 40px;
            }
          }
        }
        .team_name {
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          p {
            font-size: 12px;
            color: rgb(231, 76, 91);
          }
        }
      }
    }
  }
}
</style>
